"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PenIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M20.722,4.293,17.066,1.416a.861.861,0,0,0-.627-.176.847.847,0,0,0-.566.319l-2.9,3.685h0L4.211,16.26a.849.849,0,0,0-.157.357l-.009,0L2.971,21.741a.851.851,0,0,0,1.2.942L8.9,20.434l0,0a.835.835,0,0,0,.3-.235L17.961,9.179h0l0,0,2.9-3.688A.85.85,0,0,0,20.722,4.293ZM5.428,18.3l1.5,1.183-1.944.924Zm2.966.171-2.32-1.826,7.7-9.685L16.1,8.789ZM17.153,7.456,14.833,5.63l1.85-2.352L19,5.1Z" })));
}
exports.default = PenIcon;
